import type {TrackingData, TrackingEvents} from "../types/tracking";

import {SAN_HEADER, TRACKING_EVENT} from "../types/tracking/constants";
import {SQRL_EVENT} from "../types/sqrl/constants";

export class TrackingEvent {
  static trackHeader(san_Header: SAN_HEADER) {
    window.o_global.events<TrackingEvents>().emit(TRACKING_EVENT.SUBMIT, { san_Header });
  }

  static trackOnNextPageImpression(trackingData: TrackingData) {
    window.o_global.events<TrackingEvents>().emit(TRACKING_EVENT.ON_NEXT_PI, trackingData);
    window.o_global.debug.warn("Track on next PI submitting " + JSON.stringify(trackingData));
  }

  static track(trackingData: TrackingData) {
    window.o_global.events<TrackingEvents>().emit(TRACKING_EVENT.SUBMIT, trackingData);
    window.o_global.debug.warn("Track event submitting " + JSON.stringify(trackingData));
  }

  static createEventContext(responseEventName: SQRL_EVENT) {
    window.o_global.events<TrackingEvents>().emit(TRACKING_EVENT.CREATE_EVENT_CONTEXT, responseEventName);
  }

  static addToMergeId(trackingData: TrackingData, mergeId: string) {
    window.o_global.events<TrackingEvents>().emit(TRACKING_EVENT.ADD_TO_EVENT, trackingData, mergeId);
    window.o_global.debug.warn("Track event merge " + mergeId + " " + JSON.stringify(trackingData));
  }
}
